import { Box, Grid, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

const DEFAULT_SHORT_DESCRIPTION_MAX = 150;

const useStyles = makeStyles({
  customTextField: {
    "& input::placeholder": {
      color: "#89909A",
      opacity: 0.6,
    },
    "& .Platform-x-FilledInput-root": {
      border: "1px dashed #CCCFD4 !important",
      backgroundColor: "transparent !important",
      borderRadius: "4px",
      transition: "all 0.2s ease",
      "&:hover": {
        backgroundColor: "#F5F6F8 !important",
        border: "1px dashed #2E7BF5 !important",
      },
      "&.Mui-focused": {
        backgroundColor: "#F5F6F8 !important",
        border: "1px dashed #2E7BF5 !important",
      },
      "& input": {
        paddingLeft: "10px",
        paddingRight: "10px",
        fontWeight: 700,
        fontFamily: "Inter", // <== need to change in future
        cursor: "text",
      },
    },
  },
});

export default function ShortDescription({ state, setState }) {
  const { t } = useTranslation();
  const classes = useStyles();
  const shortDescription = state?.CommonFields?.short_description || "";

  const handleShortDescriptionChange = (event) => {
    const newValue = event.target.value;
    setState({
      ...state,
      CommonFields: {
        ...state.CommonFields,
        short_description: newValue,
      },
    });
  };

  return (
    <Box
      sx={{
        fontSize: "28px",
        marginTop: 0,
        marginBottom: 0,
        backgroundColor: "white",
      }}>
      <Grid container>
        <Grid item xs={8} md={12}>
          <TextField
            classes={{ root: classes.customTextField }}
            variant='filled'
            margin='normal'
            fullWidth
            required
            rows={3}
            multiline
            inputProps={{
              maxLength: DEFAULT_SHORT_DESCRIPTION_MAX,
            }}
            helperText={`${shortDescription.length}/${DEFAULT_SHORT_DESCRIPTION_MAX} ${t("characters")}`}
            FormHelperTextProps={{
              sx: {
                textAlign: "right",
                marginRight: 0,
              },
            }}
            id='short_description'
            name='short_description'
            autoComplete='off'
            onChange={handleShortDescriptionChange}
            placeholder={t("short_description")}
            InputProps={{ disableUnderline: true }}
            value={shortDescription}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
